import { useTranslate } from "@similarweb/i18n-provider";

import { TableWidget } from "../../../common/widget/table/TableWidget";
import { useSocialMediaEngagementData } from "../../hooks/useSocialMediaEngagementData";

import type { SocialMediaEngagementRow } from "./types";
import { useSocialMediaEngagementColumns } from "./useSocialMediaEngagementColumns";

export const SocialMediaEngagementTable = () => {
    const { translate } = useTranslate();
    const { data, isLoading } = useSocialMediaEngagementData();
    const columnsConfig = useSocialMediaEngagementColumns();

    return (
        <TableWidget<SocialMediaEngagementRow>
            dataAutomation="social-engagement-card"
            columnConfig={columnsConfig}
            data={data}
            highlightedRowSelector={(record) => record.domain.isPrimary}
            isLoading={isLoading}
            title={translate("activation.alerts.social-media.metrics.engagement.title")}
        />
    );
};
